function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { isEmpty, every, head, groupBy, flatMap } from 'lodash';
import { isUnlistedReferral, filterNetworks, programIsOffPlatform, programIsOnPlatform } from './utils';
import { useFeatureFlag } from '../../utils/useFeatureFlag';
import { OFF_PLATFORM_REFERRALS_ONLY } from './constants';

// Grouping Rules:
//  - On- and off-platform programs cannot be grouped
//  - Service must be the same
//  - Programs in coordination centers cannot be grouped
//  - Programs must be in the same network
//  - Programs in sensitive providers cannot be grouped
//  - Programs at the same provider cannot be grouped
//  - Users at sensitive providers cannot group programs
//  - Funded programs that require authroization with the same fee schedule program can be grouped
//  - Unlisted programs can only be grouped with programs in the same service and with off platform referrals

var groupByNetwork = function groupByNetwork(referral) {
  var networks = filterNetworks(referral);
  // if there is only one possible network, set the referral's network and return the referral
  if (networks.length === 1 || isUnlistedReferral(referral)) {
    referral.network = head(networks);
    return [referral];
  }
  // if there is more than one possible network, divide the programs into multiple referrals:
  // referrals with programs in providers in a single network and
  // referrals with programs in providers in multiple networks
  // referrals with unlisted programs, don't have network
  var singleNetworkPrograms = referral.programs.filter(function (program) {
    var _program$provider;
    return ((_program$provider = program.provider) === null || _program$provider === void 0 || (_program$provider = _program$provider.networks) === null || _program$provider === void 0 ? void 0 : _program$provider.length) === 1;
  });
  var multipleNetworkPrograms = referral.programs.filter(function (program) {
    var _program$provider2;
    return ((_program$provider2 = program.provider) === null || _program$provider2 === void 0 || (_program$provider2 = _program$provider2.networks) === null || _program$provider2 === void 0 ? void 0 : _program$provider2.length) > 1;
  });
  var noNetworkPrograms = referral.programs.filter(function (program) {
    var _program$provider3;
    return !((_program$provider3 = program.provider) !== null && _program$provider3 !== void 0 && (_program$provider3 = _program$provider3.networks) !== null && _program$provider3 !== void 0 && _program$provider3.length);
  });
  // group single network programs by network id
  var programsGroupedByNetworkId = groupBy(singleNetworkPrograms, 'provider.networks[0].id');
  // create a grouped referral for programs with the same single network
  var sameNetworkReferrals = Object.values(programsGroupedByNetworkId).map(function (programs) {
    var _programs$0$provider;
    return _objectSpread(_objectSpread({}, referral), {}, {
      programs: programs,
      network: head((_programs$0$provider = programs[0].provider) === null || _programs$0$provider === void 0 ? void 0 : _programs$0$provider.networks)
    });
  });
  // create separate referrals for each program with multiple networks
  var multipleNetworkReferrals = multipleNetworkPrograms.map(function (program) {
    return _objectSpread(_objectSpread({}, referral), {}, {
      programs: [program],
      network: head(networks)
    });
  });
  // create separate referrals for each program with no network
  var noNetworkReferrals = noNetworkPrograms.map(function (program) {
    return _objectSpread(_objectSpread({}, referral), {}, {
      programs: [program]
    });
  });
  return [].concat(_toConsumableArray(multipleNetworkReferrals), _toConsumableArray(sameNetworkReferrals), _toConsumableArray(noNetworkReferrals));
};
var groupByNetworkStatus = function groupByNetworkStatus(referral) {
  // if every program is on-platform or every programs is off-platform, return the referral
  if (every(referral.programs.map(function (p) {
    return programIsOnPlatform(p);
  })) || every(referral.programs.map(function (p) {
    return programIsOffPlatform(p);
  }))) {
    return [referral];
  }
  // divide programs into on- and off-platform referrals
  var inNetworkPrograms = referral.programs.filter(function (p) {
    return programIsOnPlatform(p);
  });
  var OONPrograms = referral.programs.filter(function (p) {
    return programIsOffPlatform(p);
  });
  return [].concat(_toConsumableArray(inNetworkPrograms.length ? [_objectSpread(_objectSpread({}, referral), {}, {
    programs: inNetworkPrograms
  })] : []), _toConsumableArray(OONPrograms.length ? [_objectSpread(_objectSpread({}, referral), {}, {
    programs: OONPrograms
  })] : []));
};
var groupBySensitivity = function groupBySensitivity(referral) {
  var _head;
  // if every program is non-sensitive or the referral contains only one sensitive program, return referral
  if (every(referral.programs.map(function (p) {
    var _p$provider;
    return !(p !== null && p !== void 0 && (_p$provider = p.provider) !== null && _p$provider !== void 0 && _p$provider.sensitive);
  })) || referral.programs.length === 1 && (_head = head(referral.programs)) !== null && _head !== void 0 && (_head = _head.provider) !== null && _head !== void 0 && _head.sensitive) {
    return [referral];
  }
  // create a new referral for each sensitive program
  var sensitivePrograms = referral.programs.filter(function (p) {
    var _p$provider2;
    return p === null || p === void 0 || (_p$provider2 = p.provider) === null || _p$provider2 === void 0 ? void 0 : _p$provider2.sensitive;
  }).map(function (program) {
    return _objectSpread(_objectSpread({}, referral), {}, {
      programs: [program]
    });
  });
  // create a new referral for non-sensitive programs
  var nonSensitivePrograms = referral.programs.filter(function (p) {
    var _p$provider3;
    return !(p !== null && p !== void 0 && (_p$provider3 = p.provider) !== null && _p$provider3 !== void 0 && _p$provider3.sensitive);
  });
  var nonSensitiveReferrals = !isEmpty(nonSensitivePrograms) ? [_objectSpread(_objectSpread({}, referral), {}, {
    programs: nonSensitivePrograms
  })] : [];
  return [].concat(_toConsumableArray(sensitivePrograms), nonSensitiveReferrals);
};
var groupByCC = function groupByCC(referral) {
  var _head2;
  // if no programs are in a coordination center or the referral contains only one program in a cc, return referral
  if (every(referral.programs.map(function (p) {
    var _p$provider4;
    return (p === null || p === void 0 || (_p$provider4 = p.provider) === null || _p$provider4 === void 0 ? void 0 : _p$provider4.provider_type) !== 'coordination_center';
  })) || referral.programs.length === 1 && ((_head2 = head(referral.programs)) === null || _head2 === void 0 || (_head2 = _head2.provider) === null || _head2 === void 0 ? void 0 : _head2.provider_type) === 'coordination_center') {
    return [referral];
  }
  // create a new referral for each program in a cc
  var ccPrograms = referral.programs.filter(function (p) {
    var _p$provider5;
    return (p === null || p === void 0 || (_p$provider5 = p.provider) === null || _p$provider5 === void 0 ? void 0 : _p$provider5.provider_type) === 'coordination_center';
  }).map(function (program) {
    return _objectSpread(_objectSpread({}, referral), {}, {
      programs: [program]
    });
  });
  // create a new referral for programs not in a cc
  var nonCCPrograms = referral.programs.filter(function (p) {
    var _p$provider6;
    return (p === null || p === void 0 || (_p$provider6 = p.provider) === null || _p$provider6 === void 0 ? void 0 : _p$provider6.provider_type) !== 'coordination_center';
  });
  var nonCCReferrals = !isEmpty(nonCCPrograms) ? [_objectSpread(_objectSpread({}, referral), {}, {
    programs: nonCCPrograms
  })] : [];
  return [].concat(_toConsumableArray(ccPrograms), nonCCReferrals);
};
var preventGroupingForSensitiveProvider = function preventGroupingForSensitiveProvider(referral) {
  var networks = filterNetworks(referral);
  // if there is only one possible network, set the referral's network
  if (networks.length === 1) {
    referral.network = head(networks);
  }
  var programs = referral.programs;
  return programs.length > 1 ? programs.map(function (program) {
    return _objectSpread(_objectSpread({}, referral), {}, {
      programs: [program]
    });
  }) : [referral];
};
var groupByFunded = function groupByFunded(referral) {
  var fundedWithAuthorizationPrograms = referral.programs.filter(function (p) {
    var _p$fee_schedule_progr;
    return (_p$fee_schedule_progr = p.fee_schedule_program) === null || _p$fee_schedule_progr === void 0 ? void 0 : _p$fee_schedule_progr.authorization_required;
  });
  var fundedWithoutAuthorizationPrograms = referral.programs.filter(function (p) {
    var _p$fee_schedule_progr2;
    return !((_p$fee_schedule_progr2 = p.fee_schedule_program) !== null && _p$fee_schedule_progr2 !== void 0 && _p$fee_schedule_progr2.authorization_required);
  });
  var programsGroupedByFeeSchedule = groupBy(fundedWithAuthorizationPrograms, 'fee_schedule_program.id');
  var sameFeePrograms = Object.values(programsGroupedByFeeSchedule);

  // Create a new referral for each program with a shared fee schedule program
  var sameFeeReferrals = sameFeePrograms.map(function (program) {
    return _objectSpread(_objectSpread({}, referral), {}, {
      programs: program
    }, program.length >= 2 ? {
      prevent_ungroup: true
    } : null);
  });

  // Create a new referral for programs without fee authorization required
  var nonAuthReferrals = !isEmpty(fundedWithoutAuthorizationPrograms) ? [_objectSpread(_objectSpread({}, referral), {}, {
    programs: fundedWithoutAuthorizationPrograms,
    ungroup: true
  })] : [];
  return [].concat(nonAuthReferrals, _toConsumableArray(sameFeeReferrals));
};
var groupUnlistedProgramsToReferrals = function groupUnlistedProgramsToReferrals(referrals) {
  var unlistedReferrals = [],
    listedReferrals = [];
  referrals.forEach(function (referral) {
    if (every(referral.programs, function (p) {
      return p.id.includes('unlisted');
    })) unlistedReferrals.push(referral);else listedReferrals.push(referral);
  });
  if (unlistedReferrals.length === 0) {
    return listedReferrals;
  }

  // Loop over the unlisted referrals, in case of a match, add the unlisted program to the referral 
  // and remove it from the unlisted referral
  unlistedReferrals.forEach(function (unlistedReferral) {
    var processReferral = function processReferral(referrals) {
      // Find a referral with the same service and off-platform status
      var foundReferral = referrals.find(function (referral) {
        var _unlistedReferral$pro, _referral$programs$;
        return ((_unlistedReferral$pro = unlistedReferral.programs[0]) === null || _unlistedReferral$pro === void 0 ? void 0 : _unlistedReferral$pro.services[0]) === referral.service.id && ((_referral$programs$ = referral.programs[0]) === null || _referral$programs$ === void 0 || (_referral$programs$ = _referral$programs$.status) === null || _referral$programs$ === void 0 ? void 0 : _referral$programs$.toLowerCase()) === OFF_PLATFORM_REFERRALS_ONLY;
      });
      if (foundReferral) {
        // Add the unlisted program to the referral
        foundReferral.programs.push(unlistedReferral.programs[0]);
        // Remove the unlisted program from the referral, otherwise, it will be added to referrals multiple times
        unlistedReferral.programs.splice(0, 1);
      }
    };
    processReferral(listedReferrals);
    processReferral(unlistedReferrals);
  });

  // Remove referrals with no programs
  var updatedUnlistedReferrals = unlistedReferrals.filter(function (unlistedReferral) {
    var _unlistedReferral$pro2;
    if ((unlistedReferral === null || unlistedReferral === void 0 || (_unlistedReferral$pro2 = unlistedReferral.programs) === null || _unlistedReferral$pro2 === void 0 ? void 0 : _unlistedReferral$pro2.length) > 0) return unlistedReferral;
  });
  return [].concat(listedReferrals, _toConsumableArray(updatedUnlistedReferrals));
};
export var buildGroupedReferrals = function buildGroupedReferrals(newReferrals, currentProvider) {
  var crtb1127AuthPaymentProgramsInReferrals = useFeatureFlag('crtb1127AuthPaymentProgramsInReferrals', false);
  var groupedReferrals = newReferrals;
  // if the current provider is sensitive, prevent grouping
  if (currentProvider !== null && currentProvider !== void 0 && currentProvider.sensitive) {
    groupedReferrals = flatMap(groupedReferrals, preventGroupingForSensitiveProvider);
  } else {
    var groupOperations = [];
    if (crtb1127AuthPaymentProgramsInReferrals) {
      groupOperations.push(groupByFunded);
    }
    groupOperations.push(groupByNetwork, groupByNetworkStatus, groupBySensitivity, groupByCC);
    groupOperations.forEach(function (operation) {
      groupedReferrals = flatMap(groupedReferrals, operation);
    });
    groupedReferrals = groupUnlistedProgramsToReferrals(groupedReferrals);
  }
  return groupedReferrals;
};
//# sourceMappingURL=buildGroupedReferrals.js.map